// extracted by mini-css-extract-plugin
export var active = "_ky-e";
export var blink = "_ky-f";
export var dropDownSelector = "_ky-5";
export var dropDownWrapper = "_ky-4";
export var fakeCursor = "_ky-d";
export var fontSizeButton = "_ky-7";
export var formQuillEditor = "_ky-0";
export var pressed = "_ky-g";
export var qlBlank = "_ky-1";
export var textFormattingToolbar = "_ky-2";
export var textFormattingToolbarClosed = "_ky-3";
export var textFormattingToolbarInline = "_ky-6";
export var textToolbarOption = "_ky-8";
export var toolbarCell = "_ky-a";
export var toolbarCellCollapsed = "_ky-b";
export var toolbarOptionHitArea = "_ky-c";
export var toolbarOverflow = "_ky-9";